import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";

function LambdaNode({ data, selected }) {
  const { shortName, invocations, colors } = data;

  return (
    <div
      className={`rounded-xl border-2 border-dashed min-w-[170px] shadow-sm transition-colors duration-150 cursor-pointer ${
        selected ? "ring-2 ring-ktx-purple ring-offset-2" : ""
      }`}
      style={{
        backgroundColor: colors.bg,
        borderColor: colors.border,
        color: colors.text,
      }}
    >
      <div className="px-3 py-2">
        <div className="flex items-start justify-between gap-2">
          <div className="font-semibold text-sm leading-tight">{shortName}</div>
          <span className="shrink-0 text-[9px] font-bold uppercase tracking-wider opacity-60 mt-0.5">
            λ
          </span>
        </div>
        <div className="mt-2 text-xs font-medium">
          <div className="flex justify-between gap-4">
            <span className="opacity-80">Invocations</span>
            <span>{invocations}</span>
          </div>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="pipeline-out"
        className="!w-2 !h-2 !bg-gray-400"
      />
    </div>
  );
}

export default memo(LambdaNode);
